import {useEffect, useState} from 'react';

export const useVacClient = (onError) => {
    const [vacClient, setVacClient] = useState({});

    const getComponent = async () => {
        try {
            const res = await import(
                '@vac/client' /* webpackChunkName: "vac-client" */
            );
            setVacClient({
                VacContextProvider: res.VacContextProvider,
                VacFrame: res.VacFrame,
            });
        } catch (e) {
            onError(`component_import_failed__${e?.message || ''}`);
        }
    };

    useEffect(() => {
        getComponent();
    }, []);

    return {vacClient};
};
